import upd from 'immutability-helper';
import * as Env from 'widget/env';

const useHandleRemoveReaction = (
  setMessageList: Env.SetState<Env.Message[]>,
) => {
  const handleRemoveReaction = (msg: Env.Message) =>
    setMessageList(prevValue => {
      const index = prevValue.findIndex(item => item.id == msg.id);
      if (index < 0) return prevValue;

      return upd(prevValue, { [index]: { $set: msg } });
    });

  return handleRemoveReaction;
};

export default useHandleRemoveReaction;
